import React from 'react';
import './ToS.css';

const ToS: React.FC = () => {
  return (
    <div className="tos">
      <div className="container">
        <section className="tos-header">
          <h1>Általános Szerződési Feltételek (ÁSZF)</h1>
          <p>Utolsó frissítés: 2026. február 22.</p>
        </section>

        <section className="tos-content">
          <div className="tos-section">
            <h2>1. Felek</h2>
            <div className="party-info">
              <h3>Szolgáltató:</h3>
              <p>
                Név: Lakics Márk<br />
                Vállalkozás formája: Egyéni vállalkozó<br />
                Székhely: 9073 Bőny, Szabadság út 49.<br />
                Adószám: 67003701-1-28<br />
                Telefonszám: 0036309869878<br />
                Email: info@lakicsfesto.com
              </p>
              
              <h3>Megrendelő (Ügyfél):</h3>
              <p>
                A szolgáltatást igénybe vevő természetes vagy jogi személy, 
                aki a weboldalon keresztül vagy más módon kapcsolatba lép a szolgáltatóval.
              </p>
            </div>
          </div>

          <div className="tos-section">
            <h2>2. Szolgáltatás</h2>
            <p>
              A szolgáltató vállalja, hogy a megrendelő számára szobafestési, 
              mázolási, tapétázási és kapcsolódó belsőépítészeti munkálatokat végez 
              a megállapodott feltételek szerint.
            </p>
            
            <h3>Szolgáltatások köre:</h3>
            <ul>
              <li>Belső falfestés</li>
              <li>Mázolás</li>
              <li>Tapétázás</li>
              <li>Felület előkészítés</li>
              <li>Dekoratív festés</li>
              <li>Tanácsadás színválasztásban</li>
            </ul>
          </div>

          <div className="tos-section">
            <h2>3. Árak és fizetési feltételek</h2>
            <h3>Árképzés:</h3>
            <p>
              Az árak a munka jellegétől, a felület nagyságától, a felhasznált 
              anyagok minőségétől és a munka nehézségétől függenek. Az árakról 
              minden esetben írásos árajánlatot adunk.
            </p>
            
            <h3>Fizetési módok:</h3>
            <ul>
              <li>Készpénz a munka befejezésekor</li>
              <li>Banki átutalás (számla kiállítása esetén)</li>
              <li>Részletfizetés (nagyobb munkák esetén, külön megállapodás szerint)</li>
            </ul>
            
            <h3>Számlázás:</h3>
            <p>
              A szolgáltató minden esetben számlát állít ki a megadott adatok alapján. 
              A számla tartalmazza a teljesített munkát és az anyagköltségeket.
            </p>
          </div>

          <div className="tos-section">
            <h2>4. Szerződéskötés</h2>
            <h3>Ajánlatkérés:</h3>
            <p>
              Az ajánlatkérés a weboldalon keresztül, telefonon vagy emailben lehetséges. 
              Az ajánlatkérés még nem minősül szerződésnek.
            </p>
            
            <h3>Szerződés létrejötte:</h3>
            <p>
              A szerződés akkor jön létre, amikor a szolgáltató írásos árajánlatát 
              a megrendelő elfogadja és a munka megkezdéséről megegyeznek.
            </p>
            
            <h3>Szerződés módosítása:</h3>
            <p>
              A szerződés módosítása csak a felek közös írásos megállapodásával lehetséges.
            </p>
          </div>

          <div className="tos-section">
            <h2>5. Teljesítés</h2>
            <h3>Munkakezdés:</h3>
            <p>
              A munka megkezdéséről a felek előzetesen egyeztetnek. A szolgáltató 
              törekszik a megbeszélt időpontban megkezdeni a munkát.
            </p>
            
            <h3>Határidők:</h3>
            <p>
              A munka befejezésének határidejét a szerződés rögzíti. A szolgáltató 
              a határidők tartására törekszik, de a határidők túllépése esetén 
              felelősséget csak akkor vállal, ha az a szándékosságán vagy súlyos 
                  gondatlanságán alapul.
            </p>
            
            <h3>Munkavégzés helye:</h3>
            <p>
              A munkavégzés helye a megrendelő által megadott cím. A megrendelő 
              köteles a munkavégzéshez szükséges feltételeket biztosítani.
            </p>
          </div>

          <div className="tos-section">
            <h2>6. Megrendelő kötelezettségei</h2>
            <ul>
              <li>A munkavégzés helyének biztosítása</li>
              <li>A munkaterület előkészítése (bútorok eltávolítása, védelme)</li>
              <li>A szükséges hozzáférések biztosítása</li>
              <li>A munkavégzés során fellépő problémák haladéktalan jelzése</li>
              <li>A díj határidőben történő megfizetése</li>
            </ul>
          </div>

          <div className="tos-section">
            <h2>7. Szolgáltató kötelezettségei</h2>
            <ul>
              <li>A munka szakszerű és minőségi elvégzése</li>
              <li>A megbeszélt határidők betartása</li>
              <li>A munkaterület rendben tartása</li>
              <li>A munka befejezése utáni takarítás</li>
              <li>A megrendelő tájékoztatása a munka állapotáról</li>
            </ul>
          </div>

          <div className="tos-section">
            <h2>8. Garancia</h2>
            <p>
              A szolgáltató a munkára a jogszabályok szerinti garanciát vállal. 
              A garancia időtartama általában 1 év, de ettől a felek eltérhetnek.
            </p>
            
            <h3>Garancia nem vonatkozik:</h3>
            <ul>
              <li>A megrendelő által okozott sérülésekre</li>
              <li>Nem megfelelő használatból eredő hibákra</li>
              <li>Természeti katasztrófák okozta károkra</li>
              <li>A megrendelő által biztosított anyagok hibáira</li>
            </ul>
          </div>

          <div className="tos-section">
            <h2>9. Felelősség</h2>
            <p>
              A szolgáltató felelős az általa okozott károkért. A felelősség 
              korlátozott a szolgáltatási díj összegére, kivéve, ha a kárt 
              szándékosan vagy súlyos gondatlansággal okozta.
            </p>
            <p>
              A megrendelő felelős a munkavégzés során bekövetkező károkért, 
              amelyeket ő vagy harmadik személy okoz.
            </p>
          </div>

          <div className="tos-section">
            <h2>10. Szerződés megszüntetése</h2>
            <h3>Megrendelő által:</h3>
            <p>
              A megrendelő a szerződést indoklás nélkül megszüntetheti, ha a 
              munka még nem kezdődött el. Ha a munka már megkezdődött, a 
              megrendelő csak a már elvégzett munka ellenértékének megfizetése 
              mellett szüntetheti meg a szerződést.
            </p>
            
            <h3>Szolgáltató által:</h3>
            <p>
              A szolgáltató a szerződést megszüntetheti, ha a megrendelő 
              szerződésszegést követ el, különösen ha nem biztosítja a 
              munkavégzés feltételeit vagy nem fizeti ki a díjat.
            </p>
          </div>

          <div className="tos-section">
            <h2>11. Adatvédelem</h2>
            <p>
              A szolgáltató a megrendelő személyes adatait a hatályos adatvédelmi 
              törvények szerint kezeli. Az adatkezelésről részletes információ 
              az Adatvédelmi tájékoztatóban található.
            </p>
          </div>

          <div className="tos-section">
            <h2>12. Vegyes rendelkezések</h2>
            <h3>Alkalmazandó jog:</h3>
            <p>
              A szerződésre a magyar jog az irányadó, különösen a Polgári Törvénykönyv 
              és a fogyasztóvédelemről szóló törvények.
            </p>
            
            <h3>Vitarendezés:</h3>
            <p>
              A felek közötti vitákat elsősorban békés úton próbálják rendezni. 
              Ha ez nem vezet eredményre, a fogyasztónak joga van a békéltető 
              testülethez fordulni vagy bírósági úton érvényesíteni jogait.
            </p>
            
            <h3>ÁSZF módosítása:</h3>
            <p>
              A szolgáltató fenntartja a jogot, hogy az ÁSZF-t egyoldalúan 
              módosítsa. A módosítások a weboldalon való közzététellel lépnek hatályba.
            </p>
          </div>

          <div className="tos-section">
            <h2>13. Hatálybalépés</h2>
            <p>
              Ez az ÁSZF 2026. február 22-én lép hatályba és visszavonásig 
              hatályban marad.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ToS;
